import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { DiscountAwarePriceDisplay } from '@vp/component-library';
import { useTranslations } from '@vp/om-translations';
import {
  aggregateTaxAwarePrices,
  getClusivitySeparatedPrices,
} from '@vp/om-tax-display';
import { Box } from '@vp/swan';
import useSiteData from '../../hooks/useSiteData';
import { pricingSelectors } from '../../state/pricing';
import { TaxDisplayContext } from '../shared/taxDisplay/TaxDisplayContext';
import type { RootState } from '../../types';

export const ShippingMethodPriceSummary = () => {
  const { locale } = useSiteData();
  const [cartMessages] = useTranslations(['cartMessages']);
  const { taxDisplayContext } = useContext(TaxDisplayContext) || {};

  // get the pricing for the selected cart shipping method
  const selectedShippingMethodPricing = useSelector((state: RootState) =>
    pricingSelectors.selectShippingPricing(state.pricing)
  );

  const {
    pricingData: {
      grossListCents,
      netListCents,
      grossDiscountedCents,
      netDiscountedCents,
      taxes,
      fractionDigits,
      currency: currencyCode,
    },
  } = selectedShippingMethodPricing;

  // the array of "priced components" for a single shipping option is just one object of the cents
  const shippingOptionComponents = [
    {
      grossListCents,
      netListCents,
      grossDiscountedCents,
      netDiscountedCents,
    },
  ];
  const clusivitySeparatedShippingOptionPrice = getClusivitySeparatedPrices(
    shippingOptionComponents,
    taxes
  );
  const aggregatedShippingOptionPrice = aggregateTaxAwarePrices(
    [clusivitySeparatedShippingOptionPrice],
    'shipping',
    'detailed',
    [],
    taxDisplayContext
  );

  return (
    <Box ml={1}>
      <DiscountAwarePriceDisplay
        listCents={aggregatedShippingOptionPrice.taxAwareListCents}
        discountCents={aggregatedShippingOptionPrice.taxAwareDiscountedCents}
        fractionDigits={fractionDigits}
        currencyCode={currencyCode}
        locale={locale}
        fontSize={1}
        fontWeight="bold"
        zeroOverride={cartMessages.freeShipping}
      />
    </Box>
  );
};
